module.exports = __webpack_public_path__ + "img/upload.52b141f9.svg";